import { render, staticRenderFns } from "./kycUpload2.vue?vue&type=template&id=082d317f&scoped=true&"
import script from "./kycUpload2.vue?vue&type=script&lang=js&"
export * from "./kycUpload2.vue?vue&type=script&lang=js&"
import style0 from "./kycUpload2.vue?vue&type=style&index=0&id=082d317f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082d317f",
  null
  
)

export default component.exports